import Dispatch from "./client";

const urls = {
  fcmToken: {
    url: "/token/fcm-token",
    method: "post",
  },
};

function api() {
  return {
    postFcmToken: (data) => Dispatch(urls.fcmToken, data.params, data.payload, data.options),
  };
}

export default api();
